import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Intermediario } from "../../Modelos/Intermediario";

@Injectable({
    providedIn: 'root'
})
export class IntermediariosService{
    constructor(){}

    async consultarTiposAgente(){
        let url=`${environment.backendUrl}/api/tipoAgente`;
        return await (await fetch(url, {method: "GET"})).json();
    }

    async consultarIntermediario(tipoPersona: string='I', codigoAgente: number, codigoRamo: number, codigoAgencia: number, codigoPuntoVenta: number): Promise<Intermediario>{
        let url=new URL(`${environment.backendUrl}/api/Intermediario/TipoClave`);
        let parameters = {
            CrTipoPersona: tipoPersona,
            InCodigoAgente: codigoAgente,
            cod_sucursal: codigoAgencia,
            cod_pto_vta: codigoPuntoVenta
        };
        let intermediario: Intermediario=null;
        Object.keys(parameters).forEach( key => url.searchParams.append(key, parameters[key]));
        let response=await (await fetch(url.toString(), {method: "GET"})).json();
        if(response.length!=0){
            intermediario=response[0];
            url=new URL(`${environment.backendUrl}/api/Intermediario/Comisiones`);
            let parametersComision = {
                cod_ramo: codigoRamo,
                cod_sucursal: codigoAgencia,
                cod_tipoagente: intermediario.cod_tipo_inter,
                cod_agente: codigoAgente,
                cod_usuario: 'jfernandez'
            };
            Object.keys(parametersComision).forEach( key => url.searchParams.append(key, parametersComision[key]));
            let comisiones: any[]=await (await fetch(url.toString(), {method: "GET"})).json();
            if(comisiones.length!=0){
                intermediario.porcentaje_comision=(codigoAgente==9999)?0:comisiones[0].vr_comision;
            }
            intermediario.porcentaje_participacion=100;
            intermediario.clave=codigoAgente.toString();
        }
        return intermediario;
    }

}